/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialsControllerFindAllQueryResponse, TrialsControllerFindAllQueryParams, TrialsControllerFindAll401, TrialsControllerFindAll403 } from "../../models/trialsController/TrialsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trialsControllerFindAll } from "../../clients/trialsService/trialsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trialsControllerFindAllQueryKey = (params: TrialsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/trials'
}, ...(params ? [params] : [])] as const;
export type TrialsControllerFindAllQueryKey = ReturnType<typeof trialsControllerFindAllQueryKey>;
export function trialsControllerFindAllQueryOptions(params?: TrialsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trialsControllerFindAllQueryKey(params);
  return queryOptions<TrialsControllerFindAllQueryResponse, ResponseErrorConfig<TrialsControllerFindAll401 | TrialsControllerFindAll403>, TrialsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trialsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List trials (paginated)
 * {@link /api/v1/trials}
 */
export function useTrialsControllerFindAll<TData = TrialsControllerFindAllQueryResponse, TQueryData = TrialsControllerFindAllQueryResponse, TQueryKey extends QueryKey = TrialsControllerFindAllQueryKey>(params?: TrialsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrialsControllerFindAllQueryResponse, ResponseErrorConfig<TrialsControllerFindAll401 | TrialsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trialsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...trialsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrialsControllerFindAll401 | TrialsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}